import { Page } from './page';

/**
 * An array of data with an associated page object used for paging
 */
export class PagedData<T> {
  data = new Array<T>();
  page = new Page();

  ///Quotations
  awaiting: number = 0;
  assigned: number = 0;
  completed: number = 0;
  rejected: number = 0;
}


